import * as React from "react";
import { Box } from "@mui/material";
import PayrollReports from "./reports/payrollReports";

const GeneralTab: React.FC = () => (
    <Box sx={{ width: 1, height: 1 }}>
        <PayrollReports />
    </Box>
);

export default GeneralTab;
